<template>
  <div class="page-content">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="order-list">
          <div
            class="item"
            v-for="(item, index) in orders"
            :key="index"
            @click="$router.push('/user/order/details?id=' + item.id)"
          >
            <div
              class="preview-img"
              :style="{ backgroundImage: 'url(' + goodImg + ')' }"
            ></div>
            <div class="item-info">
              <div class="title">繁花相送</div>
              <div class="author">冷峻</div>
              <div class="price">12.0元</div>
            </div>
            <div
              class="item-status"
              :class="item.status == '0'? '' : item.status == '1'? 'success' : 'fail'"
            >
              {{
                item.status == "0"
                  ? "待付款"
                  : item.status == "1"
                  ? "交易成功"
                  : "交易关闭"
              }}
            </div>
          </div>
        </div>

        <div class="com-empty" v-show="orders.length < 1">
          <div class="empty">
            <div>
              <p>暂无订单</p>
              <img src="../../../assets/images/common/ic-empty.png" alt="" />
              
              <div class="set-btn2" style="margin-top:0.5rem">
                <van-button @click="$router.replace('/goods')" >前往购买</van-button>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>


<script>
import Vue from "vue";
import { List, PullRefresh,Button } from "vant";

Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Button);

export default {
  name: "order-list",
  data() {
    return {
      orders: [],
      goodImg: require("../../../assets/images/home/goods/pic.png"),
      loading: false,
      finished: false,
      refreshing: false,
    };
  },

  mounted() {},

  methods: {
    onLoad() {

     

      setTimeout(() => {
        this.loading = false;
        this.finished = true;
        this.refreshing = false;
      }, 1000);
      
      // setTimeout(() => {
      //   if (this.refreshing) {
      //     this.orders = [];
      //     this.refreshing = false;
      //   }

      //   for (let i = 0; i < 10; i++) {
      //     this.orders.push(this.orders.length + 1);
      //   }
      //   this.loading = false;
      //   if (this.orders.length >= 40) {
      //     this.finished = true;
      //   }
      // }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();


    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
  padding: 0 0.3rem;
}
.order-list {
  .item {
    background-image: linear-gradient(left, #d3cec5, #b7afa1);
    border-radius: 0.15rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0.26rem;
    margin-bottom: 0.28rem;
    .preview-img {
      width: 1.15rem;
      height: 1.15rem;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 0.1rem;
    }
    .item-info {
      flex: 1;
      color: #252424;
      line-height: 1.2;
      padding-left: 0.15rem;
      .title {
        font-size: 0.28rem;
      }
      .author {
        font-size: 0.22rem;
        color: #505050;
        margin: 0.1rem 0;
      }
      .price {
        font-size: 0.28rem;
      }
    }
    .item-status {
      color: #ffffff;
      font-size: 0.31rem;
      &.success {
        color: #089101;
      }
      &.fail {
        color: #000;
      }
    }
  }
}
.com-empty {
  height: 8rem;
  position: relative;
  min-height: 50vh;
  .empty {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 0.3rem 0;
    img {
      width: 2.36rem;
      margin-top: 0.25rem;
    }
    p {
      color: #444444;
      font-size: 0.36rem;
    }
  }
}
</style>
